var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.app_classes,attrs:{"id":"app"}},[(this.$store.state.ps)?_c('div',{staticClass:"banner_ps"},[_vm._v(" 27 IARC Participating States ")]):_vm._e(),(_vm.is_factsheet==false)?_c('LayoutIarc',{attrs:{"website_title":'Cancer TODAY',"website_url":this.$store.state.env.BASE_URL,"website_logo":_vm.logo,"website_mobile_logo":_vm.logoMobile,"website_menu":[
      { label : 'Home' , path : '/today' , route : 'home' , class : 'current' , is_home : true } , 
      { label : 'About' , path : '/today/about' , route : 'about' } , 
      { label : 'Data & methods' , path : '/today/data-sources-methods' , route : 'data-sources-methods' , 
        submenu : [
          { label : 'Incidence' , hash : '#incidence' } , 
          { label : 'Mortality' , hash : '#mortality' } , 
          { label : 'Prevalence' , hash : '#prevalence' } , 
          { label : 'Cancer dictionary' , hash : '#cancer-dictionary' } , 
          { label : 'Population dictionary' , hash : '#population-dictionary' } , 
          { 
            label : 'Supplemented material including the list of cancer registries that contributed to the GLOBOCAN project' , 
            hash : '#' 
          } , 
          { 
            label : 'Cancer incidence and mortality data: sources and methods by country' , 
            hash : '#' 
          } 
        ] 
      } ,
      { label : 'Population factsheets' , path : '/today/population-factsheets'  , route : 'population-fact-sheets'} , 
      { label : 'Cancer factsheets' , path : '/today/population-factsheets'  , route : 'cancer-fact-sheets'} , 
      { label : 'Dataviz' , path : '/today/dataviz' , route : 'dataviz' } 
    ]}}):_vm._e(),(_vm.is_factsheet==true)?_c('FactsheetLayout'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }